import type { Testimonial } from "@/api/sourceData.service";
import { languageName } from "./languageName";
import { sourceDataDate } from "./sourceDataDate";
import { testimonialStatusLabel } from "./sourceDataStatus";
import { DASH } from "./dash";

export type TestimonialPageNames = {
  editionName: string;
  firmName: string;
  rankingEntityName: string;
  bpaName: string;
};

export type TestimonialRow = { label: string; value: string; tooltip: string | null };

export type TestimonialCard = {
  id: string;
  publication: string;
  status: string | null;
  quote: string;
  rows: TestimonialRow[];
};

export function testimonialCards(
  testimonials: Testimonial[],
  names: TestimonialPageNames,
): TestimonialCard[] {
  return testimonials.map(testimonial => ({
    id: testimonial.id,
    publication: names.editionName,
    status: testimonialStatusLabel(testimonial.status),
    quote: testimonial.content,
    rows: [
      { label: "Organisation", value: names.firmName, tooltip: null },
      { label: "Region", value: names.rankingEntityName, tooltip: null },
      { label: "Practice", value: names.bpaName, tooltip: null },
      { label: "Individual", value: testimonial.lawyerName ?? DASH, tooltip: null },
      {
        label: "Language",
        value: languageName(testimonial.language),
        tooltip: "Input language / Output language",
      },
      { label: "Created", value: sourceDataDate(testimonial.createdAt) ?? DASH, tooltip: null },
    ],
  }));
}
